/** Labels definition for ENGLAND ENGLISH */
module.exports = {
    __title__:                    'Chat',
    __need_help__:                'Do you need help?',
    __ongoing_chat__:             'Open Chat',
    __name__:                     'Name',
    __email__:                    'Email',
    __signup__:                   'Start chat',
    __noagents__:                 'There are no agents at this moment. Try again later.',
    __noworkingtime__:            'Chat is closed at this moment.',
    __invalid_name_size__:        'Name cannot be empty',
    __invalid_name__:             'Name cannot contain strange characters',
    __invalid_email__:            'You must provide a valid email address',
    __AGENT_IS_WRITING__:         'Agent is writing',
    __USER_IS_WRITING__:          'User is writing',
    __USER_ONLINE__:              'online',
    __USER_AWAY__:                'away',
    __START_CHAT_WITH_AGENT__:    'Start chat with agent',
    __PLEASE_ENTER_YOUR_NAME__:   'Please, enter your name',
    __WELCOME__:                  require('./welcome.hbs'),
    __LOOKING_FOR_AN_AGENT__:     'We are looking for an agent, please wait...',
    __USER_JOINED_CONVERSATION__: require('./user_joined_conversation.hbs'),
    __BTN_SEND__:                 'Send',
    __ERR_EMPTY_MESSAGE__:        'No empty messages',
    __CLOSE_CONFIRM__:            'Do you really want to close and leave chat?',
    __CHAT_FINISHED__:            'Chat finished',
    __USER_LEFT__:                require('./user_left.hbs'),
    __USER_INVITED__:             require('./user_invited.hbs'),
    __USER_REJECTED__:            require('./user_rejected.hbs'),
    __NO_AGENTS__:                'There are no agents available at this moment',
    __BTN_DOWNLOAD__:             'Download conversation',
    __CONVERTED_TO_TICKET__:      require('./converted_to_ticket.hbs'),
    __YES__:                      'yes',
    __NO__:                       'no',
    __CONNECTING__:               'Connecting...',
    __CHAT_CONTINUE_TO_CUSTOMER_LINK__: 'Please note that this link will lead to an external page that may not belong to Backstage or Inbenta. Please proceed at your own risk.',
    __BTN_CANCEL__:               'Cancel',
    __ERR_MESSAGE_TOO_LONG__:     require('./err_message_too_long.hbs'),
    __CHAT_START__:               'Started chat with ',
    __CHAT_USER_DISCONNECT__:     'User disconnected. Chat finished',
    __CHAT_USER_NOT_CONNECTED__:  'not connected',
    __CHAT_CONVERTING_TO_TICKET__:'Converting to ticket...',
    __UPLOADING__:                'Uploading...',
    __CHAT_INTERVENED_BY_AGENT__: 'This chat has been intervened',
    __CHAT_INTERVENED_BY_ME__:    'You have intervened this chat',
    __INVITATION_EXPIRING__:      require('./invitation_expiring.hbs'),
};



// WEBPACK FOOTER //
// ./i18n/en_EN/labels.js